import * as momentTZ from "moment-timezone";


export const timeZoneTexasDateNow = () => {
    return momentTZ().tz("America/Chicago").format('YYYY-MM-DDTHH:mm:ss')
}

export const formatTimeZoneTexas = (date: Date | string) => {
    return momentTZ(date).tz("America/Chicago").format('YYYY-MM-DDTHH:mm:ss')
}